import { right } from 'fp-ts/lib/Either';
import { Option, some } from 'fp-ts/lib/Option';
import { SyntheticLayerInfo } from '../app';
import { FetchData } from '../map';
import {
    Feature,
    GeometryType,
    ILayerInfo,
    Inspire,
    StyleConfig,
} from '../source';

export const makeMetadata = (
    id: string,
    geometryType: GeometryType,
): Inspire => ({
    id,
    geometryType,
    resourceTitle: { fr: id, nl: id },
    resourceAbstract: { fr: id, nl: id },
    uniqueResourceIdentifier: id,
    topicCategory: [],
    keywords: [],
    geographicBoundingBox: { west: 0.0, north: 0.0, east: 0.0, south: 0.0 },
    temporalReference: { creation: 'NOW', revision: 'NOW' },
    responsibleOrganisation: [],
    metadataPointOfContact: [],
    metadataDate: 'NOW',
    published: false,
    // deprecated: use resourceUrls['data']
    dataStreamUrl: null,
    resourceUrls: {},
    maintenanceFrequency: 'unknown',
});

export const makeLayerInfo = (id: string, style: StyleConfig): ILayerInfo => ({
    id,
    legend: null,
    group: null,
    metadataId: id,
    featureViewOptions: { type: 'default' },
    visible: true,
    visibleLegend: false,
    opacitySelector: false,
    style,
    selectable: true,
});

export const makeSyntheticLayerInfoFunction =
    (id: string, geometryType: GeometryType, style: StyleConfig) =>
    (): Option<SyntheticLayerInfo> =>
        some({
            name: { fr: id, nl: id },
            info: makeLayerInfo(id, style),
            metadata: makeMetadata(id, geometryType),
        });

export const makeFetchData =
    (id: string, features: Feature[]): FetchData =>
    () =>
        right(some({ id, type: 'FeatureCollection', features }));

export const clientLayer = (
    id: string,
    geometryType: GeometryType,
    style: StyleConfig,
    features: Feature[],
) => {
    const layer = makeLayerInfo(id, style);
    const info = makeSyntheticLayerInfoFunction(id, geometryType, style);
    const data = makeFetchData(id, features);

    return { style, data, info, layer };
};

export default clientLayer;
